<template>
  <v-container fluid>
    <div id="app">
      <v-app id="inspire">
        <!--Signupg Title-->
        <v-layout row wrap>
          <v-row align="center" justify="center">
            <v-col cols="auto" md="auto">
              <v-flex sm="15">
                <h1>Get Started here with signup</h1>
              </v-flex>
            </v-col>
          </v-row>
        </v-layout>

        <!--Error Alert-->
        <v-layout v-if="error">
          <v-flex xs12 sm6 offset-sm3>
            <form-alert :message="error.message"></form-alert>
          </v-flex>
        </v-layout>
        <v-layout row wrap>
          <v-flex xs12 sm6 offset-sm3>
            <v-card color="accent" dark max-width="344" class="mx-auto">
              <v-container>
                <v-form
                  v-model="isFormValid"
                  lazy-validation
                  ref="form"
                  @submit.prevent="handleSignupUser"
                >
                  <v-layout row>
                    <v-flex xs12>
                      <v-text-field
                        :rules="userEmailRules"
                        v-model="userEmail"
                        autocomplete="email"
                        prepend-icon="mail"
                        label="User Email"
                        type="text"
                        required
                      ></v-text-field>
                    </v-flex>
                    <v-flex xs12>
                      <v-text-field
                        :rules="userEmailRules"
                        v-model="userEmail"
                        prepend-icon="account_circle"
                        autocomplete="email"
                        label="User Name"
                        type="text"
                        readonly
                      ></v-text-field>
                    </v-flex>
                  </v-layout>
                  <v-layout row>
                    <v-flex xs12>
                      <v-text-field
                        :rules="userNameRules"
                        v-model="userName"
                        autocomplete="name"
                        prepend-icon="face"
                        label="Real Name"
                        hint="Will be shown in all statistics"
                        type="text"
                        required
                      ></v-text-field>
                    </v-flex>
                    <v-flex xs12 sm6 md4>
                      <v-select
                        v-model="gender"
                        cy-data="gender_dropdown"
                        :items="['male', 'female', 'intersex']"
                        label="Gender"
                        :rules="requiredRule"
                        prepend-icon="gender"
                        :menu-props="{ contentClass: 'gender-dropdown-in' }"
                      ></v-select>
                    </v-flex>
                    <v-flex xs4 sm4 md4>
                      <v-text-field
                        v-model="role"
                        cy-data="role_dropdown"
                        :items="['Administrator', 'user']"
                        label="Role"
                        prepend-icon="role"
                        v-show="role_disabled"
                        :menu-props="{ contentClass: 'role-dropdown-in' }"
                      ></v-text-field>
                    </v-flex>
                    <v-flex xs12 sm6 md4>
                      <v-menu
                        v-model="menu"
                        :close-on-content-click="false"
                        :nudge-right="40"
                        transition="scale-transition"
                        offset-y
                        min-width="290px"
                      >
                        <template v-slot:activator="{ on }">
                          <v-text-field
                            cy-data="birthdate-selector-txt"
                            v-model="birthDate"
                            label="Birth Date"
                            :rules="requiredRule"
                            prepend-icon="event"
                            v-on="on"
                            readonly
                            :menu-props="{ contentClass: 'birthdate-selector' }"
                          ></v-text-field>
                        </template>
                        <v-date-picker
                          :menu-props="{ contentClass: 'birthday-datepicker' }"
                          v-model="birthDate"
                          @input="menu = false"
                        ></v-date-picker>
                      </v-menu>
                    </v-flex>
                  </v-layout>
                  <v-layout row>
                    <v-flex xs12>
                      <v-text-field
                        :rules="passwordRules"
                        v-model="password"
                        autocomplete="new-password"
                        prepend-icon="extension"
                        label="Password"
                        type="password"
                        required
                      ></v-text-field>
                    </v-flex>
                  </v-layout>
                  <v-layout row>
                    <v-flex xs12>
                      <v-text-field
                        id="cy-test"
                        :rules="passwordRules"
                        v-model="passwordConfirmation"
                        prepend-icon="gavel"
                        label="Confirm Password"
                        type="password"
                        required
                      ></v-text-field>
                    </v-flex>
                  </v-layout>
                  <v-layout row>
                    <v-flex xs12>
                      By marking checkboxes and Signing-up you confirm that
                      you've read and agreed on
                      <a
                        href="../../OlympianGuruPrivacyPolicy.pdf"
                        target="_blank"
                        >OlympianGuruPrivacyPolicy</a
                      >
                      and
                      <a
                        href="../../OlympianGuruTermsOfService.pdf"
                        target="_blank"
                        >OlympianGuruTermsOfService</a
                      >
                      <v-checkbox
                        id="checkboxOG"
                        v-model="privacyPolicy"
                        label="OlympianGuruPrivacyPolicy"
                      ></v-checkbox>
                      <v-checkbox
                        id="checkbox-TermsOfService"
                        v-model="privacyTermsOfService"
                        label="OlympianGuruTermsOfService"
                      ></v-checkbox>
                    </v-flex>
                  </v-layout>
                  <v-layout row>
                    <v-flex xs12>
                      <v-btn
                        :loading="loading"
                        :disabled="
                          !isFormValid ||
                            loading ||
                            !privacyPolicy ||
                            !privacyTermsOfService
                        "
                        color="info"
                        type="submit"
                        data-cy="SignupButton"
                      >
                        <span slot="loader" class="custom-loader">
                          <v-icon light>cached</v-icon>
                        </span>
                        Signup
                      </v-btn>

                      <h3>
                        Already have an account?
                        <router-link to="/auth/signin">Signin</router-link>
                      </h3>
                    </v-flex>
                  </v-layout>
                </v-form>
              </v-container>
            </v-card>
          </v-flex>
        </v-layout>
      </v-app>
    </div>
  </v-container>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  data() {
    return {
      menu: false,
      userEmail: "",
      birthDate: "",
      privacyPolicy: false,
      privacyTermsOfService: false,
      gender: "",
      role: "",
      role_disabled: false,
      password: "",
      passwordConfirmation: "",
      userName: "",
      username: "",
      isFormValid: true,
      userNameRules: [
        userName => !!userName || "User Name is required",
        userName =>
          userName.length < 20 || "Username can not be more than 20 characters"
      ],
      userEmailRules: [
        v => !!v || "E-mail is required",
        v =>
          /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/.test(
            v
          ) || "E-mail must be valid" // eslint-disable-line
      ],
      requiredRule: [v => !!v || "Value is required"],
      passwordRules: [
        password => !!password || "Password is required",
        password =>
          password.length >= 4 || "Password must be at least 4 characters",
        confirmation => confirmation === this.password || "Passwords must match"
      ]
    };
  },

  computed: {
    ...mapGetters(["loading", "error", "user"])
  },

  watch: {
    user(value) {
      //
      // if user value changes б redirect to home page
      if (value) {
        this.$router.push("/landing");
      }
    }
  },
  methods: {
    handleSignupUser() {
      if (this.$refs.form.validate()) {
        this.$store.dispatch("signUpUser", {
          userName: this.userName,
          userEmail: this.userEmail,
          password: this.password,
          birthDate: this.birthDate,
          gender: this.gender,
          createDate: new Date().toISOString().substr(0, 10),
          role: this.role ? this.role : "user",
          updateSource: "OlympianGuruApp"
        });
      }
    }
  }
};
</script>

<style>
.custom-loader {
  animation: loader 1s infinite;
  display: flex;
}
@-moz-keyframes loader {
  from {
    transform: rotate(0);
  }
  to {
    transform: rotate(360deg);
  }
}
@-webkit-keyframes loader {
  from {
    transform: rotate(0);
  }
  to {
    transform: rotate(360deg);
  }
}
@-o-keyframes loader {
  from {
    transform: rotate(0);
  }
  to {
    transform: rotate(360deg);
  }
}
@keyframes loader {
  from {
    transform: rotate(0);
  }
  to {
    transform: rotate(360deg);
  }
}
</style>
